import type { SupportedLocale } from '@firmable/i18n';
import { DEFAULT_LOCALE } from '@firmable/i18n';
import { create } from 'zustand';

interface LocaleState {
  /** The active locale (e.g., 'en-AU', 'fr-CA', 'ja-JP') */
  locale: SupportedLocale;
  /** Whether the user has explicitly chosen a locale (vs. auto-derived) */
  isExplicit: boolean;
}

interface LocaleActions {
  /** Set the locale explicitly (user chose it in settings) */
  setLocale: (locale: SupportedLocale) => void;
  /** Derive locale from a country code (used on first load if no explicit choice) */
  initFromCountry: (country: AvailableCountries) => void;
}

// Locale switching is disabled until i18n is officially released to customers.
// All users see DEFAULT_LOCALE ('en-AU') regardless of any persisted or
// country-derived state. Persistence is intentionally dropped so any locale
// previously stored from country auto-derivation is ignored on next load.
const useLocaleStore = create<LocaleState & LocaleActions>()(() => ({
  locale: DEFAULT_LOCALE,
  isExplicit: false,
  setLocale: () => {},
  initFromCountry: () => {},
}));

export { useLocaleStore };
